module.exports = __webpack_public_path__ + "img/31w52nd.112c3ec1.png";